import React, {Component} from 'react';
import './PortalScreen.css';
import PortalNav from "./Parts/PortalNav";
import PortalHeader from "./Parts/PortalHeader";
import PropTypes from 'prop-types';

export default class PortalScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileExpanded: false
        };
    }

    handleBurgerClick() {
        this.setState({
            mobileExpanded: true
        });
    }

    handleMobileMenuClose() {
        this.setState({
            mobileExpanded: false
        });
    }

    render() {
        return (
            <div className={"PortalScreen"}>

                <PortalHeader title={this.props.title} subText={this.props.subText} isLoading={this.props.isLoading}
                              onBurgerClick={this.handleBurgerClick.bind(this)}/>
                <PortalNav tab={this.props.tab} mobileExpanded={this.state.mobileExpanded}
                            onMobileClose={this.handleMobileMenuClose.bind(this)}/>

                <div className={"PortalScreen__inner"}>
                    {this.props.children}
                </div>

            </div>
        );
    }
}

PortalScreen.propTypes = {
    tab: PropTypes.string,
    title: PropTypes.string,
    subText: PropTypes.string,
    isLoading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/PortalScreen.js